import { createContext, useContext, ReactNode, useState } from 'react';
import { Direction } from '../components/RTLLayout';

const env = process.env;

interface Config {
  environment: string;
  apiBaseUrl: string;
  seqaiApiBaseUrl: string;
  direction: Direction;
  updateDirection: (newDirection: Direction) => void;
}

const ConfigContext = createContext<Config | null>(null);

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};

interface ConfigProviderProps {
  children: ReactNode;
}

export const ConfigProvider = ({ children }: ConfigProviderProps) => {
  const savedLang = localStorage.getItem('i18nextLng');
  const [direction, setDirection] = useState<Direction>(
    savedLang === 'ar' ? 'rtl' : (env.REACT_APP_APP_DIRECTION || 'ltr') as Direction
  );

  const updateDirection = (newDirection: Direction) => {
    setDirection(newDirection);
  };

  const config: Config = {
    environment: env.REACT_APP_ENVIRONMENT || 'development',
    apiBaseUrl: env.REACT_APP_API_BASE_URL || '',
    seqaiApiBaseUrl: env.REACT_APP_SEQAI_API_BASE_URL || 'http://localhost:8008',
    direction,
    updateDirection,
  };

  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
};
